import { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import {
  AbaceText,
  AbaceTitle,
  Ellipse,
  EllipseText,
  FirstRowAbace,
  HorizontalDivision,
  ImageFirstRow,
  WrapContentFirstRow,
  WrapTextsFirstRow,
  VideoContainer,
  ContainerBehindVideo,
  ContainerBehindVideo2,
} from "../../styles/About";
import HistoryAbout from "../../components/HistoryAbout/HistoryAbout";
import Footer from "../../components/Footer/Footer";
import HistoryInfoModel from "../../data/model/history_info";
import { getAboutAbace } from "../../data/services/about_service";
import { endpoint } from "../../utils/Constants";


export default function About() {
  const [aboutData, setAboutData] = useState<HistoryInfoModel | null>(null);

  useEffect(() => {
    async function fetchData() {
      const { sobre } = await getAboutAbace();
      if (sobre.length > 0) {
        setAboutData(sobre[0]);
      }
    }
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <FirstRowAbace>
        <WrapContentFirstRow>
          <VideoContainer>
            <ContainerBehindVideo />
            <ContainerBehindVideo2 />
            {aboutData?.videoUrl ? (
              <ImageFirstRow autoPlay loop muted>
                <source
                  src={`${endpoint}${aboutData.videoUrl}`}
                  type="video/mp4"
                />
                Seu navegador não suporta o elemento de vídeo.
              </ImageFirstRow>
            ) : null}
          </VideoContainer>
          <WrapTextsFirstRow>
            <AbaceTitle>A ABACE</AbaceTitle>
            {aboutData?.inicio && (
              <AbaceText
                responsive
                dangerouslySetInnerHTML={{ __html: aboutData.inicio }}
              />
            )}
          </WrapTextsFirstRow>
        </WrapContentFirstRow>
      </FirstRowAbace>
      <HorizontalDivision>
        <Ellipse>
          <EllipseText>Nossa história</EllipseText>
        </Ellipse>
      </HorizontalDivision>
      <HistoryAbout />
      <Footer />
    </>
  );
}
